export function removeNullFromObj(obj) {
  return Object.fromEntries(
    Object.entries(obj)
      .filter(([_, value]) => value != null && value != "")
      .map(([key, value]) => [
        key,
        value === Object(value) ? removeNullFromObj(value) : value,
      ])
  );
}
export function isEmpty(value) {
  return (
    value === null ||
    value === undefined ||
    value === "" ||
    (Array.isArray(value) && value.length === 0) ||
    (!(value instanceof Date) &&
      typeof value === "object" &&
      Object.keys(removeNullFromObj(value)).length === 0) ||
    (!(value instanceof Date) &&
      typeof value === "object" &&
      // Object.keys(value).length === 1 &&
      Object.keys(removeNullFromObj(value)).some((i) => value[i] === ""))
  );
}
export const isVideo = (value) => {
  const videoPattern = /\.(mp4|webm|ogg)/i; // You can add more video extensions
  return value.match(videoPattern);
};
export const isImage = (value) => {
  const imagePattern = /\.(jpeg|jpg|gif|png|webp)/i; // You can add more image extensions
  return value.match(imagePattern);
};
export const CUSTOMER_CONTACT = [
  { id: 1, name: "Email" },
  { id: 2, name: "Whatsapp" },
  { id: 3, name: "Text message" },
];
export const truncateText = (text, maxLength) => {
  if (text && text.length > maxLength) {
    return text.substring(0, maxLength) + "..."; // Adjust the ellipsis or customize the message
  }
  return text;
};